module.exports = "/images/icono-historial-black.svg?5704ae46e019db24d22ba4e9ab0951e3";